import { CATEGORY_BY_NAME } from "../data/mealMedia";
import normalizeName from "./normalizeName";

const categorizeMeal = (meal) => {
  const normalized = normalizeName(meal?.name);
  const category = CATEGORY_BY_NAME[normalized];

  if (!category && process.env.NODE_ENV !== "production") {
    console.warn("Missing category mapping for meal:", meal?.name);
  }

  return category || null;
};

export default categorizeMeal;
